var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _vm.device.mac_address
        ? _c(
            "el-row",
            { staticClass: "form-row", attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("label", [_vm._v("Old Product Type")]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "highlight",
                    attrs: {
                      readonly: "",
                      value: _vm.currentProduct.description,
                      name: "old_product_type",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("label", [_vm._v("Old Product Color")]),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "highlight",
                    attrs: {
                      readonly: "",
                      value: _vm.device.profile.color || "N/D",
                      name: "old_product_color",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("label", [_vm._v("Reason Group")]),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    effect: "dark",
                    content: "Refresh data",
                    placement: "top",
                  },
                },
                [
                  _c("RefreshButton", {
                    staticClass: "flex-shrink",
                    staticStyle: { padding: "0" },
                    attrs: { text: false },
                    on: { click: _vm.refreshReasons },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "el-input" },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "Please select group",
                        name: "reason_group",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.resetReason()
                        },
                      },
                      model: {
                        value: _vm.request_reasons.reason_group,
                        callback: function ($$v) {
                          _vm.$set(_vm.request_reasons, "reason_group", $$v)
                        },
                        expression: "request_reasons.reason_group",
                      },
                    },
                    _vm._l(_vm.currentGroups, function (group) {
                      return _c("el-option", {
                        key: group.id,
                        attrs: { label: group.value, value: group.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "form-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              {
                staticClass: "clearfix",
                staticStyle: { "margin-bottom": "5px" },
              },
              [
                _c(
                  "label",
                  [
                    _vm._v("\n          Reason\n          "),
                    _vm.request_reasons.return_label
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: "warning",
                              effect: "plain",
                              size: "mini",
                            },
                          },
                          [_vm._v("With Return Label")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "el-input" },
              [
                _c(
                  "el-select",
                  {
                    attrs: {
                      filterable: "",
                      clearable: "",
                      disabled: !_vm.request_reasons.reason_group,
                      placeholder: "Please select reason",
                      name: "reason",
                    },
                    on: { change: _vm.setReturnLabel },
                    model: {
                      value: _vm.new_reason.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_reason, "id", $$v)
                      },
                      expression: "new_reason.id",
                    },
                  },
                  _vm._l(_vm.currentReasons, function (reason) {
                    return _c(
                      "el-option",
                      {
                        key: reason.id,
                        attrs: {
                          label: reason.value + " - " + reason.text,
                          value: reason.id,
                        },
                      },
                      [
                        _c("span", { staticStyle: { float: "left" } }, [
                          _vm._v(
                            _vm._s(reason.value) + " - " + _vm._s(reason.text)
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              color: "#8492a6",
                              "font-size": "13px",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                reason.return_label ? "With Return Label" : ""
                              )
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "center-buttons" },
        [
          _c(
            "el-button",
            {
              attrs: { plain: "" },
              on: {
                click: function ($event) {
                  return _vm.back()
                },
              },
            },
            [_vm._v("\n      Back\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "info", plain: "" },
              on: {
                click: function ($event) {
                  return _vm.reset()
                },
              },
            },
            [_vm._v("\n      Reset\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { disabled: !_vm.isValid, type: "primary", plain: "" },
              on: {
                click: function ($event) {
                  return _vm.next()
                },
              },
            },
            [_vm._v("\n      Next\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }